import * as Yup from 'yup'

export interface ICreateAccount {
  selectTemplate: string
  senderEmail: string
  subject: string
  footer: false
  quillText: string
  personalizeEmail: boolean
  selectedInvestorUserIds: []
  checkedAll: boolean
  selectedTypeInvestor: string
  pitchDeckId: string
  updateId: string
  bccEmail:string
  toExistingInvestors: boolean
}
export interface ICreateAccount2 {}

const sendEmailAccountSchemas = [
  Yup.object({
    senderEmail: Yup.string().required().label('Select Email'),
    subject: Yup.string().required().label('Subject '),
    quillText: Yup.string().required().label('Body '),
  }),
  Yup.object({
    selectedTypeInvestor: Yup.string().required().label('Select Type '),
    selectedInvestorUserIds: Yup.array()
      .min(1, 'selectedInvestorUserIds must have at least 2 values')
      .of(Yup.object()),
  }),
]

const inits2: ICreateAccount2 = {}

export {sendEmailAccountSchemas, inits2}
